import { Button, HStack, Tooltip } from '@chakra-ui/react';
import React from 'react';
import { FaTrash } from 'react-icons/fa';
import { useContextSelector } from 'use-context-selector';
import Emoji from '../Emoji';
import EditorContext from './EditorContext';
import { composerEvent } from './useComposerState';

export const BackToWritingDeskButton = () => {
  const dispatch = useContextSelector(EditorContext, (c) => c.dispatch);
  return (
    <Tooltip label="Your draft is safe and sound">
      <span>
        <Button onClick={() => dispatch({ type: 'Navigator', event: 'Root' })}>
          <Emoji symbol="👈" label="Quill" spaceRight /> Back to writing desk
        </Button>
      </span>
    </Tooltip>
  );
};

export const ActionButtons = () => {
  const dispatch = useContextSelector(EditorContext, (ctx) => ctx.dispatch);

  return (
    <HStack>
      <Button onClick={() => dispatch(composerEvent({ type: 'STAGE_FOR_SENDING' }))}>
        <Emoji symbol="📮" label="Emoji of a post box" spaceRight />
        Send Letter
      </Button>
      <Button
        colorScheme="red"
        onClick={() => dispatch(composerEvent({ type: 'STAGE_FOR_DELETION' }))}
      >
        <FaTrash />
      </Button>
    </HStack>
  );
};
